import { useQuery } from 'urql';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { useErrorBoundary } from 'react-error-boundary';
import { healthyDealsCategoryListQuery } from '../../graphql/queries';
import ListOfDeals from '../ListOfDeals/ListOfDeals';
import { sendDataToAnalytics } from '../../utils/misFunctions';
import { useHealthyDealsDataContext } from '../HealthyDealsDataContextProvider/HealthyDealsData.context';
import ResponsiveChipSkeleton from '../Skeletons/ResponsiveChipSkeleton';

const ResponsiveChipsWithSkeleton = ({
	data = {},
	selectedCategory = {},
	handleChipClick = () => null,
	fetching = false,
}) => {
	const { showBoundary } = useErrorBoundary();

	const isLoading = !data || fetching;
	return (
		<Stack display="flex" flexWrap="wrap" direction="row" gap={1}>
			{isLoading ? (
				// Display skeletons when data is loading
				<ResponsiveChipSkeleton />
			) : (
				// Display chips when data is available
				data?.healthyDealsFilterList?.options?.map(category => (
					<Chip
						key={category.id}
						variant={
							selectedCategory?.id === category?.id &&
							selectedCategory?.label === category?.label
								? 'filled'
								: 'outlined'
						}
						label={category.label}
						onClick={e => {
							e.preventDefault();
							try {
								sendDataToAnalytics({
									eventName: `categoryClick_${category.label}`,
								});
								handleChipClick(category);
							} catch (error) {
								showBoundary(error);
							}
						}}
						color="secondary"
					/>
				))
			)}
		</Stack>
	);
};

ResponsiveChipsWithSkeleton.propTypes = {
	data: PropTypes.shape({
		healthyDealsFilterList: PropTypes.shape({
			options: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
				}),
			),
		}),
	}),
	selectedCategory: PropTypes.object,
	handleChipClick: PropTypes.func,
	fetching: PropTypes.bool,
};

export default function ListOfCategoriesWithDeals() {
	// throw new Error('testing');
	const { selectedCategorySavedInContext, setSelectedCategorySavedInContext } =
		useHealthyDealsDataContext();

	const handleChipClick = chip => {
		if (
			chip?.id === selectedCategorySavedInContext?.id &&
			chip?.label === selectedCategorySavedInContext?.label
		) {
			setSelectedCategorySavedInContext(null);
		} else {
			setSelectedCategorySavedInContext(chip);
		}
	};
	const [result] = useQuery({
		query: healthyDealsCategoryListQuery,
	});

	const { fetching, data, error } = result;

	if (error) {
		throw error; // should bubble up to the consumer
	}
	return (
		<>
			<ResponsiveChipsWithSkeleton
				data={data}
				selectedCategory={selectedCategorySavedInContext}
				handleChipClick={handleChipClick}
				fetching={fetching}
			/>
			<section>
				<ListOfDeals category={selectedCategorySavedInContext} />
			</section>
		</>
	);
}
